import { CommonModule, DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MaterialModule } from 'src/app/material.module';
import { AbdmHealthRecordsService } from './abdm-health-records.service';
import { TablerIconsModule } from 'angular-tabler-icons';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from 'src/app/common/dateFormat';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
  selector: 'app-abdm-consent-request-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MaterialModule, TablerIconsModule, TranslateModule],
    providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  templateUrl: './abdm-consent-request-dialog.component.html'
})
export class AbdmConsentRequestDialogComponent {
  readonly hiTypes = ['OPConsultation', 'Prescription', 'DischargeSummary', 'DiagnosticReport'];
  submitting = false;
  readonly form;
  minDate: Date;
  today: Date;
  maxDate: Date;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { patientId: number },
    private dialogRef: MatDialogRef<AbdmConsentRequestDialogComponent>,
    private formBuilder: FormBuilder,
    private service: AbdmHealthRecordsService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    const now = new Date();
    this.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    this.maxDate = now;
    this.minDate = new Date(1800, 0, 1);
    const from = new Date(now); from.setFullYear(from.getFullYear() - 1);
    this.form = this.formBuilder.group({
      purposeCode: ['CAREMGT', Validators.required],
      purposeText: ['Care Management', Validators.required],
      hiTypes: [this.hiTypes, Validators.required],
      permissionFrom: [from, Validators.required],
      permissionTo: [now, Validators.required],
      dataEraseAt: [this.today, Validators.required]
    });
  }

  submit(): void {
    if (this.form.invalid || this.submitting) return;
    this.submitting = true;
    const value = this.form.getRawValue();
    this.service.createConsent({
      patientId: this.data.patientId,
      purposeCode: value.purposeCode!,
      purposeText: value.purposeText!,
      hiTypes: value.hiTypes!,
      permissionFrom: value.permissionFrom!.toISOString(),
      permissionTo: value.permissionTo!.toISOString(),
      dataEraseAt: this.toEndOfDayIso(value.dataEraseAt!)
    }).subscribe({
      next: response => {
        this.toastr.success(response.message || this.translate.instant('ABDM.CONSENT_CREATED'));
        this.dialogRef.close(true);
      },
      error: (error: HttpErrorResponse) => {
        this.submitting = false;
        const message = error.error?.message || this.translate.instant('ABDM.CONSENT_CREATE_FAILED');
        this.toastr.error(message);
      }
    });
  }

  private toEndOfDayIso(value: Date): string {
    return moment(value).endOf('day').toISOString();
  }
}
